import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { updatePreference, UpdatePreferenceDto } from '@creditsights/api-ui-web';
import { Preference } from '../../models/Preference';
import { RecentSearch } from '../../models/RecentSearch';
import { queryKeys } from '../queryKeyFactory';
import { getSortedRecentSearches } from './useFetchRecentSearches';
import { Channels } from '../../utils/channels';

export interface UpdateRecentSearchPayload extends UpdatePreferenceDto<RecentSearch[]> {
  id: string;
}

export default (): UseMutationResult<void, void, UpdateRecentSearchPayload, { previousSearches }> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      const updatedRecentSearches = await updatePreference(payload.id, payload);
      queryClient.setQueryData([queryKeys.recentSearches.all], getSortedRecentSearches(updatedRecentSearches));
      Channels.recentSearchesChannel.postMessage(null);
    },
    {
      onMutate: async (payload) => {
        // Cancel any outgoing refetches (so they don't overwrite our optimistic update)
        await queryClient.cancelQueries([queryKeys.recentSearches.all]);

        const previousSearches = queryClient.getQueryData<Preference>([queryKeys.recentSearches.all]);

        queryClient.setQueryData([queryKeys.recentSearches.all], payload);

        return { previousSearches };
      },
      onError: (error, searches, context) => {
        queryClient.setQueryData([queryKeys.recentSearches.all], context?.previousSearches);
      },
    }
  );
};
